module.exports = __webpack_public_path__ + "img/136.c3de618d.jpg";